import { _ as b } from "./index830.mjs";
import { _ as T } from "./index831.mjs";
import { _ as j } from "./index832.mjs";
import { _ as M } from "./index833.mjs";
import { _ as v } from "./index834.mjs";
import { _ as C } from "./index660.mjs";
import { _ as k } from "./index835.mjs";
var a = b, t = T, o = j, i = M, s = v, S = C, e = k, g = "[object Map]", V = "[object Object]", _ = "[object Promise]", f = "[object Set]", w = "[object WeakMap]", u = "[object DataView]", d = e(a), D = e(t), P = e(o), W = e(i), G = e(s), r = S;
(a && r(new a(new ArrayBuffer(1))) != u || t && r(new t()) != g || o && r(o.resolve()) != _ || i && r(new i()) != f || s && r(new s()) != w) && (r = function(n) {
  var m = S(n), c = m == V ? n.constructor : void 0, p = c ? e(c) : "";
  if (p)
    switch (p) {
      case d:
        return u;
      case D:
        return g;
      case P:
        return _;
      case W:
        return f;
      case G:
        return w;
    }
  return m;
});
var $ = r;
export {
  $ as _
};
